import { Polygon } from "../api/types";
import { PlantationProjectType, SoilProjectType, VegProjectType } from "./sum";

export const getInContact = () => ({
  name: "contact_clicked",
  params: {
    section: "Contact"
  }
});

export const completePolygon = (polygon: Polygon) => ({
  name: "complete_polygon",
  params: {
    section: "FarmDetails",
    polygon: JSON.stringify(polygon)
  }
});

export const selectModal = (
  type: VegProjectType | SoilProjectType | PlantationProjectType
) => ({
  name: "select_method",
  params: {
    section: "MethodDiscovery",
    method_type: type
  }
});

export const estimateCalculatedProject = (
  type:
    | SoilProjectType.BeefHerdManagement
    | SoilProjectType.CarbonSoilSequestration
) => ({
  name: "calculate_estimate",
  params: {
    section: "Estimate",
    project_type: type
  }
});

export const saveAsPdfMethodDiscovery = () => ({
  name: "export_pdf",
  params: {
    section: "MethodDiscovery"
  }
});

export const saveAsPdfMethodModal = (
  type: VegProjectType | SoilProjectType | PlantationProjectType
) => ({
  name: "export_pdf",
  params: {
    section: "MethodModal",
    method_type: type
  }
});
